// Comparator mode prices the whole catalogue before the customer gave their real
// consumption, so it falls back to representative yearly values.
const FALLBACK_CAR_ELEC = 4000
const FALLBACK_CAR_GAS = 8000

export const comparatorConsumption = consumptionData => {
  const { carBase, carHp, carHc, carGas } = consumptionData ?? {}

  const hphc = (carHp || 0) + (carHc || 0)

  return {
    carElec: carBase || hphc || FALLBACK_CAR_ELEC,
    carGas: carGas || FALLBACK_CAR_GAS,
    gasUnit: 'kWh',
  }
}
